import { render } from "./QuestionsBankModal.vue?vue&type=template&id=42e9058c"
import script from "./QuestionsBankModal.vue?vue&type=script&lang=js"
export * from "./QuestionsBankModal.vue?vue&type=script&lang=js"

import "./QuestionsBankModal.vue?vue&type=style&index=0&id=42e9058c&lang=css"
script.render = render

export default script